/* eslint-disable complexity */
/* eslint-disable max-lines */
import React, { useMemo, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { change, getFormValues } from 'redux-form';
import { setClickAnalyticsData, trackClick, trackPageView } from '@tcp/core/src/analytics/actions';
import L3NavigationCarousel from '@tcp/core/src/components/common/molecules/L3NavigationCarousel';
import {
  isCanada,
  getBrandInCaps,
  getViewportInfo,
  getAPIConfig,
  parseBoolean,
} from '@tcp/core/src/utils';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import {
  getCurrentCurrency,
  getCurrencyAttributes,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import { getDefaultStore } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getFavoriteStore } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import { getToastModalState } from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.selectors.js';
import { showToastModal } from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions.js';
import { addToCartEcom } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import createPayload from '@tcp/core/src/components/features/browse/ProductListing/molecules/utils/filterAnalytics';
import SeoHeaderSection from '@tcp/core/src/components/common/molecules/SeoHeaderSection';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import { globalCommonBrowseLabels } from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import Recommendations from '@tcp/core/src/components/common/molecules/Recommendations';
import { clearRecommendationData } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import { getProducts } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import { removePatternsFromSeoTitle } from '@tcp/web/src/components/features/browse/CategoryListingPage/clpContainerHelper';
import {
  setConsolidatedPlpRes,
  setBopisFilterState,
  setPriceFilterFlag,
} from './CategoryListingPage.actions';
import {
  getTotalProductsCount,
  getUnbxdCallByPageNumber,
  getCategoryProductsByPage,
  getTitleDataPerPage,
  getInitialValues,
  getLongDescription,
  getNavigationData,
  getIsBopisFilterOn,
  getIsPaginatedPlpLoading,
  getIsInitialCall,
  getIsL2Category,
  getCurrentPageNumber,
  getCategoryId,
  getGenericCarousel,
  getIsShowL2Skeleton,
  getAppliedFilters,
  getAppliedSortId,
  getIsServiceError,
  getCurrentNavIds,
  getIsPaginatedAlternatePlpEnabled,
  getIsLayoutFetched,
  getCurrentNavId,
  getFilterMaps,
  getIsPromoCallCompletedForCategory,
  getIsPromoCombinationHasTopPromos,
  getAspectRatioForCategory,
  getIsStageHoldCategoriesOosMessage,
  getIsHidePlpGridAndFilters,
  getCategoryModuleFilters,
  getQuickFilters,
  getSeoTitle,
} from './CategoryListingPage.selectors';
import {
  PlpGrid,
  PlpGridColumn,
  StyledLoaderSkelton,
  RenderText,
  TopPromoWrapper,
  StyledReadMore,
  ItemsCountWrapper,
  ItemsCount,
  ItemsText,
  TopPromoWrapperV3,
  CategoryPromotionWrapper,
  TrendingInCategoryCarouselWrapper,
} from '../styles/PaginatedPage.style';
import PaginatedPage from '../views/PaginatedPage.view';
import {
  getPLPGridPromos,
  getPlpCrossPromo,
  getSpotlightReviewsUrl,
} from '../../ProductListing/container/ProductListing.selectors';
import { getServerTimeFromState } from '../../../../common/organisms/Promotions/container/Promotions.selectors';
import {
  getIsBrierleyPromoEnabled,
  getIsBuyMorePromoEnabled,
  getIsInternationalShipping,
  getIsNewNavigationImagesEnabled,
  getIsPLPCarouselEnabled,
  getNumberOfProductsPerPage,
  getAbTestIsTopRatedBadgeEnabled,
  getAbTestIsBestSellerBackAbTestEnabled,
  getIsNewSwatchURLEnabled,
  isShopThisStoreModeOn,
  getIsNewPlpImageBorderEnabled,
  getIsNewPlpPaginatorEnabled,
  getAbTestIsNewPlpPaginatorShowingResultEnabled,
  getIsAlternatePLPEnabled,
  getIsGenericSBCRedesignEnabled,
  getSortByRatingLabel,
  getIsOneClickATCEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getAbTestIsMostFavoritedBackAbEnabled,
  getABTestSetPLPSLPAddToCartCTA,
  getIsInfluencerBadgeEnabledForListingPages,
  getisRatingRedesignAbTest,
  getIsPromotionRedesignAbTest,
  getTileRedesignAB,
  getInfluencerPicksEnabled,
  getSeoHeaderAlignTopEnabled,
  getIsAlternateImageOnHoverEnabled,
  getIsShowPriceRange,
  isPixleeWebEnabled,
  getOutfitCarouselPillCategories,
  getIsFacetedNavigationEnabled,
  getSeoFacetedNavigationConfig,
  getStyliticsV3CarouselTags,
  getIsTrendingInCategoryRecommendationsEnabled,
  getIsCleanUrlForSizeEnabled,
  getIsTrendingInCategoryRecommendationsDisplayBadgeEnabled,
  getTrendingInCategoryCarouselCatIds,
  getIsOneHrFilterEnabled,
  getIsUpdatedPromotionsDisplayEnabled,
  getPLPImageSizeConfig,
  getIsOutfitCarouselPillEnabled,
  getOutfitCarouselPillCategoriesAB,
  getSBCDesignVariationRectangle,
  getSBCDesignVariationCircle,
  getIsPillVariationEnabledOnAllPlps,
  getIsFullWidthInGridPromoHidden,
  getIsDynamicColorSwatchesEnabled,
  getIsHoverToPreviewColorSwatchesEnabled,
  getIsInteractiveColorSwatchBandEnabled,
  getIsHoverToRevealATBButtonEnabled,
  getIsFourTileGridEnabled,
  getTsSwatchColorUrlEnabled,
  getIsClickableBrandBadgesEnabled,
  getIsQuickFiltersModuleEnabled,
  getIsPLPDynamicGridHeroEnabled,
  getIsQuickFiltersEnabled,
  getIsRemoveCategoryBreakEnabled,
  getIsFinalSaleBackABEnabled,
  getIsRandomBgColorEnabled,
  getIsDynamicBadgeEnabled,
  getIsDisableDynamicBadgeFlagAbtest,
  getIsCollectionSeoForPlpEnabled,
  getFadeImageHoverEnabled,
  getIsTransparentImageSizeReduced,
  getAddToDefaultFavoritesEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import PromoModules from '../../../../common/organisms/PromoModules';
import {
  getFiltersPayload,
  getFiltersPayloadSeo,
  getPlpUrlQueryValues,
  getNavigationTree,
  showNewCarousel,
  getShowCmsCarouselFlag,
  getIsVariation3OutfitCarousel,
  getIsPromoCarouselToBerendered,
  getPlpUrlQueryValuesSeo,
} from './CategoryListingPage.utils';
import withLazyLoad from '../../../../common/hoc/withLazyLoad';
import { setPlpProductData } from '../../ProductDetail/container/ProductDetail.actions';
import { setPlpDataForQuickView } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { isPlccUser } from '../../../account/User/container/User.selectors';
import useClpAnalytics from './hooks/useClpAnalytics';
import { HEADER_LONGER_BRAND_IDS } from '../../../../../constants/brandSpecific.constants';
import { SHOP_THIS_STORE_URL_QUERY_KEY } from '../../../../../constants/shopThisStore.constant';
import {
  getCarouselDataString,
  hasSbcContentChanged,
} from '../../ProductListing/container/PlpCarousel.utils';
import { setIsHplp } from '../../HorizontalCategory/container/HorizontalCategory.actions';
import CarouselSkeleton from '../molecules/CarouselSkeleton';
import GenericSkeleton from '../molecules/GenericSkeleton/views/GenericSkeleton.view';
import CategoryPromotion from '../molecules/CategoryPromotion/views/CategoryPromotion.view';
import { PROMO_FLAGS } from '../../../../../constants/plp.constants';
import CategoryModuleFilter from '../molecules/CategoryModuleFilter/views/CategoryModuleFilter';
import getPdpBrandLabel from '../../ProductDetail/molecules/ProductBasicInfo/helpers/ProductBasicInfoHelper';
import getImageData from '../../PlpTile/views/plpTileHelpers/imageDataHelper';
import {
  extractBaseUrl,
  getImageAssetConfig,
  isBundleProduct,
} from '../../PlpTile/views/plpTileHelpers/plpTileCommonHelpers';
import { extractAttributeValue } from '../../../../../services/abstractors/productListing/productParser';

const styleClassName = 'plp-promo-module';

const CategoryFilters = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "category-filters" */ '../molecules/ClpFilters/container/ClpFilters.container'
    ),
  {
    ssr: false,
    loading: () => {
      return <StyledLoaderSkelton />;
    },
  }
);

const Spotlights = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "spotlight-container" */ '../../ProductListing/molecules/Spotlight/views/Spotlight'
    ),
  {
    ssr: false,
  }
);

const StyliticsCarouselView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "stylistics-carousel" */ '@tcp/core/src/components/common/molecules/ShopByLookStylitics'
  )
);

const SpotlightsLazyLoaded = withLazyLoad(Spotlights);

const getFormData = (filtersFromUrl) => {
  let formDetails = filtersFromUrl;
  if (isShopThisStoreModeOn()) {
    formDetails = {
      ...filtersFromUrl,
      mode: [SHOP_THIS_STORE_URL_QUERY_KEY],
    };
  }
  return formDetails;
};

const TopPromos = ({
  genericCarouselData,
  processedBreadCrumbs,
  pathName,
  isPromoForMobile,
  trackHorizontalPlpAnalytic,
  plpTopPromos,
  dynamicPromoModules,
  isPLPCarouselEnabled,
  isGenericSBCRedesignEnabled,
  isSbcContentChanged,
  sbcTypeValue,
  layoutFetched,
  outfitCarouselPillCategories,
  totalProductsCount,
  isPaginatedPlpLoading,
  hasMounted,
  currentNavId,
  isOutfitCarouselPillDesignEnabled,
  outfitCarouselPillCategoriesAB,
  sbcDesignVariationRectangle,
  sbcDesignVariationCircle,
  isPromoCallCompleted,
  hasTopPromos,
  isOutfitPillVariationEnabledOnAllPlps,
  shouldHideLeftNavigation,
  isMountedHideLeftNavigationOnPLPEnabled,
  // eslint-disable-next-line consistent-return, sonarjs/cognitive-complexity
}) => {
  const plpGenericCarouselDefaultTitle = getLabelFromCopyOrFromTranslation(
    'global.CommonBrowseLabels.lbl_plp_carousel_default_title',
    globalCommonBrowseLabels
  );
  const showGenericCarousel = showNewCarousel(
    plpTopPromos,
    isPLPCarouselEnabled,
    genericCarouselData,
    sbcTypeValue
  );
  const showCmsCarousel = getShowCmsCarouselFlag(showGenericCarousel, sbcTypeValue, plpTopPromos);
  const currentListingName =
    processedBreadCrumbs[processedBreadCrumbs.length - 1].displayName || '';
  const asPath = pathName?.split('/c/')[1] || '';
  const brandId = HEADER_LONGER_BRAND_IDS[getBrandInCaps()];

  const isCmsCarouselAvailable = sbcTypeValue === PROMO_FLAGS.cmsBasedCarousel;
  const isEmptyPage = totalProductsCount === 0 && !isPaginatedPlpLoading && hasMounted;
  const showSkeleton = isCmsCarouselAvailable && !layoutFetched && !isEmptyPage;
  const cmsCarouselWrapperClassName =
    isCmsCarouselAvailable && getIsPromoCarouselToBerendered(plpTopPromos) ? styleClassName : '';
  const pillCategoriesArray = outfitCarouselPillCategories?.split(',');
  const pillCategoriesABVal = outfitCarouselPillCategoriesAB?.split(',');
  const isPillVariation =
    Array.isArray(pillCategoriesArray) &&
    pillCategoriesArray.length > 0 &&
    pillCategoriesArray.some((element) => {
      return element?.trim()?.toString() === currentNavId?.trim()?.toString();
    });
  const isPillVariationAB =
    isOutfitCarouselPillDesignEnabled &&
    Array.isArray(pillCategoriesABVal) &&
    pillCategoriesABVal.length > 0 &&
    pillCategoriesABVal.some((element) => {
      return element?.trim()?.toString() === currentNavId?.trim()?.toString();
    });
  const isPillEnabled = isPillVariation || isPillVariationAB;

  const overrideCmsCarouselClassName =
    cmsCarouselWrapperClassName === styleClassName && !isPillEnabled ? styleClassName : '';

  const enableCMSPromos = parseBoolean(getAPIConfig()?.enableCMSPromos) ?? false;
  if (showGenericCarousel && genericCarouselData && genericCarouselData.carouselData) {
    return (
      <L3NavigationCarousel
        categoryFilters={genericCarouselData && genericCarouselData.carouselData}
        carouselTitle={
          (genericCarouselData && genericCarouselData.carouselTitle) ||
          plpGenericCarouselDefaultTitle
        }
        asPath={asPath}
        showCarousel={showGenericCarousel}
        brandId={brandId}
        trackHorizontalPlpAnalytic={trackHorizontalPlpAnalytic}
        breadcrumb={processedBreadCrumbs}
        showPLPGenericCarousel
        plpSbc
        isPLP={'plp'}
        isPromoForMobile={isPromoForMobile}
        isGenericSBCRedesignEnabled={isGenericSBCRedesignEnabled}
        isSbcContentChanged={isSbcContentChanged}
      />
    );
  }

  const PromoModulesCmp = (
    <div
      className={`${overrideCmsCarouselClassName} ${
        isPillEnabled ? 'pill-variation-plp-promo' : ''
      }`}
    >
      <PromoModules
        isOutfitCarouselPillDesignEnabled={isPillEnabled}
        plpTopPromos={plpTopPromos}
        dynamicPromoModules={dynamicPromoModules}
        currentListingName={currentListingName}
        isPromoForMobile={isPromoForMobile}
        currentPathName={asPath}
        sbcDesignVariationRectangle={sbcDesignVariationRectangle}
        sbcDesignVariationCircle={sbcDesignVariationCircle}
        isOutfitPillVariationEnabledOnAllPlps={isOutfitPillVariationEnabledOnAllPlps}
        shouldHideLeftNavigation={shouldHideLeftNavigation}
        isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
      />
    </div>
  );

  const SkeletonCmp = (
    <>
      <div
        className={`plp-carousel-skeleton-${asPath} ${isPillEnabled ? '' : 'carousel-skeleton'}`}
      >
        <CarouselSkeleton
          isOutfitCarouselPillDesignEnabled={isPillEnabled}
          isOutfitPillVariationEnabledOnAllPlps={isOutfitPillVariationEnabledOnAllPlps}
        />
      </div>
      <div className={`plp-generic-skeleton-${asPath}`}>
        <GenericSkeleton />
      </div>
    </>
  );

  if (
    enableCMSPromos &&
    isPromoCallCompleted &&
    plpTopPromos.length !== 0 &&
    plpTopPromos[0]?.moduleName
  ) {
    return PromoModulesCmp;
  }

  if (enableCMSPromos && isPromoCallCompleted && hasTopPromos) {
    return SkeletonCmp;
  }

  if (enableCMSPromos && !isPromoCallCompleted && isCmsCarouselAvailable && !isEmptyPage) {
    return SkeletonCmp;
  }

  if (showSkeleton) {
    return SkeletonCmp;
  }

  if (showCmsCarousel && plpTopPromos.length > 0) {
    return PromoModulesCmp;
  }
};

const TrendingInCategoryCarousel = ({
  isTrendingInCategoryRecommendationsEnabled,
  processedBreadCrumbs,
  appliedFilterIdsAndLength,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
  trendingInCategoryCarouselCatIds,
  isDynamicBadgeEnabledAbtest,
}) => {
  if (isTrendingInCategoryRecommendationsEnabled && appliedFilterIdsAndLength?.filterCount === 0) {
    let primaryCategory = '';
    if (processedBreadCrumbs && processedBreadCrumbs.length > 0) {
      const { categoryId } = processedBreadCrumbs[processedBreadCrumbs.length - 1];
      primaryCategory = categoryId;
    }

    if (primaryCategory && trendingInCategoryCarouselCatIds?.includes(primaryCategory)) {
      return (
        <Recommendations
          portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.TRENDING_IN_CATEGORY_PRODUCTS}
          page={Constants.RECOMMENDATIONS_PAGES_MAPPING.PLP}
          isTrendingInCategoryRecommendations
          sequence="1"
          primaryCategory={primaryCategory}
          isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
            isTrendingInCategoryRecommendationsDisplayBadgeEnabled
          }
          isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
        />
      );
    }
    return null;
  }
  return null;
};

const extractPTagContent = (htmlString) => {
  if (!htmlString) return '';
  const pTagMatch = htmlString.match(/<[Pp]>(.*?)<\/[Pp]>/);
  return pTagMatch ? pTagMatch[1] : htmlString;
};

const checkFilterAppliedStatus = (filterCountVal, bopisFilterStatus, sortingKey) =>
  filterCountVal !== 0 || parseBoolean(bopisFilterStatus) || !isEmpty(sortingKey);

// eslint-disable-next-line sonarjs/cognitive-complexity
const PaginatedPageContainer = (props) => {
  const {
    pathName,
    paginationObj,
    totalProductsCount,
    recordsPerPage,
    paginatedProducts,
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    wishListData,
    plpGridPromos,
    plpCrossPromos,
    isShortImage,
    processedBreadCrumbs,
    selectedPageProductCount,
    initialValues,
    className,
    longDescription,
    navigationData,
    isBopisFilterOn,
    isPaginatedPlpLoading,
    isL2Category,
    isInitialCall,
    pageNumber,
    promotionsData,
    serverTime,
    isBuyMorePromoEnabled,
    trackClickPromotion,
    setUpdatedUrlActn,
    categoryId,
    spotlightUrl,
    saveProductDataForPdp,
    seoHeaderCopy,
    plpTopPromos,
    categoryHasCMSPromoCombinations,
    dynamicPromoModules,
    trackWishListClick,
    isLoggedIn,
    saveProductDataForQV,
    isPlcc,
    isInternationalShipping,
    isBrierleyPromoEnabled,
    genericCarouselData,
    isPLPCarouselEnabled,
    isShowL2Skeleton,
    currency,
    currencyAttributes,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    isSyteEnabled,
    isNewSwatchUrlEnabled,
    trackHorizontalPlpAnalytic,
    isServiceError,
    isNewPLPAtbCardTileEnabled,
    isNewPLPImageBorderEnabled,
    isNewPlpPaginatorEnabled,
    isPLPCategoryPillsEnabled,
    isNewPlpPaginatorShowingResultEnabled,
    isAlternatePlpEnabled,
    currentNavIds,
    trackCategoryPillClick,
    isPaginatedAlternatePlpEnabled,
    trackPaginationClick,
    isNewNavigationImagesEnabled,
    isGenericSBCRedesignEnabled,
    sortByRatingLabel,
    addToBagEcom,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    sbcTypeValue,
    isMostFavoritedBadgeEnabled,
    setPLPSLPAddToCartCTA,
    isInfluencerBadgeEnabled,
    isRatingRedesignAbTest,
    isTileRedesignAB,
    isInfluencerPicksEnabled,
    appliedFilters,
    setIsHplpPage,
    favAddRemoveLoadingState,
    toastModalState,
    showToastModalAction,
    layoutFetched,
    currentNavId,
    isSeoHeaderAlignTopEnabled,
    isSeoHeaderCopyLoaded,
    isAlternateImageOnHoverEnabled,
    shouldRenderSkeletonComponent,
    isShowPriceRangeEnabled,
    isPixleeWidget,
    outfitCarouselPillCategories,
    isFacetedNavigationEnabled,
    seoFacetedNavigationConfig,
    styliticsV3CarouselTags,
    isTrendingInCategoryRecommendationsEnabled,
    appliedFilterIdsAndLength,
    isCleanUrlForSizeEnabled,
    filterMaps,
    isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
    trendingInCategoryCarouselCatIds,
    clearRecommendationDataForPLP,
    recommendationProducts,
    isOneHrFilterEnabled,
    isUpdatedPromotionsDisplayEnabled,
    imageConfigWithoutDPR,
    isOutfitCarouselPillDesignEnabled,
    outfitCarouselPillCategoriesAB,
    sbcDesignVariationRectangle,
    sbcDesignVariationCircle,
    isPromoCallCompleted,
    hasTopPromos,
    aspectRatioForCategory,
    isStageHoldCategoryOosMessage,
    isOutfitPillVariationEnabledOnAllPlps,
    hidePlpGridAndFilters,
    isFullWidthInGridPromoHidden,
    isDynamicColorSwatchesEnabled,
    isHoverToPreviewColorSwatchesEnabled,
    isInteractiveColorSwatchBandEnabled,
    isHoverToRevealATBButtonEnabled,
    isFacetedNavigationNoIndexApplicableCheck,
    isFourTileGridEnabled,
    isSwatchAsColorUrlEnabled,
    isFeatureBrandEnabled,
    isQuickFiltersModuleEnabled,
    categoryModuleFilters,
    updateBopisFormValue,
    newFormData,
    setPriceFilterFlagActn,
    isPLPDynamicGridHeroEnabled,
    isMountedHideLeftNavigationOnPLPEnabled,
    isQuickFiltersEnabled,
    hideFilters,
    setHideFilters,
    shouldHideLeftNavigation,
    isRemoveCategoryBreakEnabled,
    quickFilters,
    isPLPSortAndOneHrFilterRedesignEnabled,
    isFinalSaleABEnabled,
    appliedSort,
    isRandomBgColorEnabled,
    isDynamicBadgeEnabled,
    isDynamicBadgeEnabledAbtest,
    isCollectionSeoPlpEnabled,
    isFadeImageHoverEnabled,
    seoTitle,
    isTransparentImageSizeReduceEnabled,
    addToDefaultFavoritesEnabled,
  } = props;
  const hasMounted = useHasMounted();
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  const ItemLabel = renderLabel(slpLabels.lbl_item, 'lbl_item');
  const ItemsLabel = renderLabel(slpLabels.lbl_items, 'lbl_items');

  useClpAnalytics(props);
  let primaryCategory;
  if (processedBreadCrumbs && processedBreadCrumbs.length > 0) {
    const currentCategoryBreadcrumbData = processedBreadCrumbs[processedBreadCrumbs.length - 1];
    primaryCategory = currentCategoryBreadcrumbData.categoryId;
  }

  const carouselDataRef = useRef({});
  const primaryCategoryRef = useRef(primaryCategory);
  const carouselDataStr = getCarouselDataString(genericCarouselData || {});
  const [isSbcContentChanged, setIsSbcContentChanged] = useState(false);
  useEffect(() => {
    if (
      primaryCategoryRef.current !== primaryCategory &&
      isTrendingInCategoryRecommendationsEnabled &&
      recommendationProducts?.length > 0
    ) {
      clearRecommendationDataForPLP({ reduxKey: Constants.RECOMMENDATIONS_PAGES_MAPPING.PLP });
    }

    if (
      primaryCategoryRef.current !== primaryCategory &&
      isMountedHideLeftNavigationOnPLPEnabled &&
      !hideFilters
    ) {
      setHideFilters(true);
    }
    primaryCategoryRef.current = primaryCategory;
  }, [primaryCategory]);

  useEffect(() => {
    carouselDataRef.current.prev = carouselDataRef.current?.next;
    carouselDataRef.current.next = carouselDataStr;
    const isChanged = hasSbcContentChanged(
      carouselDataRef.current.prev,
      carouselDataRef.current.next
    );
    setIsSbcContentChanged(isChanged);
  }, [carouselDataStr, pathName]);

  const navTree = useMemo(() => {
    return getNavigationTree(navigationData, pathName);
  }, [navigationData, pathName]);

  useEffect(() => {
    if (isPaginatedPlpLoading) {
      document.getElementById('web-app-content')?.classList.remove('mainPageHeight');
    }
    return () => {
      document.getElementById('web-app-content')?.classList.add('mainPageHeight');
    };
  }, [isPaginatedPlpLoading]);
  const submitSortChange = (sortSelected) => {
    let clothingSize = {};
    if (isCleanUrlForSizeEnabled && filterMaps?.v_clothingsize_uFilter) {
      clothingSize = filterMaps.v_clothingsize_uFilter;
    }
    const { asPath, filtersFromUrl } = isFacetedNavigationEnabled
      ? getFiltersPayloadSeo(
          pathName,
          {
            ...initialValues,
            sort: sortSelected,
          },
          isFacetedNavigationEnabled,
          seoFacetedNavigationConfig,
          { isCleanUrlForSizeEnabled, clothingSizeMap: clothingSize }
        )
      : getFiltersPayload(pathName, {
          ...initialValues,
          sort: sortSelected,
        });
    const formDetails = getFormData(filtersFromUrl);
    const updatedUrl = isFacetedNavigationEnabled
      ? getPlpUrlQueryValuesSeo(formDetails, asPath, true, 1, seoFacetedNavigationConfig, {
          isCleanUrlForSizeEnabled,
          clothingSizeMap: clothingSize,
        })
      : getPlpUrlQueryValues(formDetails, asPath, true, 1);

    setUpdatedUrlActn({ updatedUrl });
    const SortForAA = createPayload(appliedFilters);
    pushEventToAdobeAnalytics('apply_sort', { sortSelected, SortForAA });
  };

  useEffect(() => {
    setIsHplpPage(false);
  }, []);

  const renderTopPromos = (isPromoForMobile) => {
    return (
      <TopPromos
        processedBreadCrumbs={processedBreadCrumbs}
        pathName={pathName}
        genericCarouselData={genericCarouselData}
        trackHorizontalPlpAnalytic={trackHorizontalPlpAnalytic}
        plpTopPromos={plpTopPromos}
        categoryHasCMSPromoCombinations={categoryHasCMSPromoCombinations}
        dynamicPromoModules={dynamicPromoModules}
        isPLPCarouselEnabled={isPLPCarouselEnabled}
        isPromoForMobile={isPromoForMobile}
        isGenericSBCRedesignEnabled={isGenericSBCRedesignEnabled}
        isSbcContentChanged={isSbcContentChanged}
        sbcTypeValue={sbcTypeValue}
        layoutFetched={layoutFetched}
        isInitialCall={isInitialCall}
        outfitCarouselPillCategories={outfitCarouselPillCategories}
        totalProductsCount={totalProductsCount}
        isPaginatedPlpLoading={isPaginatedPlpLoading}
        hasMounted={hasMounted}
        currentNavId={currentNavId}
        isOutfitCarouselPillDesignEnabled={isOutfitCarouselPillDesignEnabled}
        outfitCarouselPillCategoriesAB={outfitCarouselPillCategoriesAB}
        sbcDesignVariationRectangle={sbcDesignVariationRectangle}
        sbcDesignVariationCircle={sbcDesignVariationCircle}
        isPromoCallCompleted={isPromoCallCompleted}
        hasTopPromos={hasTopPromos}
        aspectRatioForCategory={aspectRatioForCategory}
        isOutfitPillVariationEnabledOnAllPlps={isOutfitPillVariationEnabledOnAllPlps}
        shouldHideLeftNavigation={shouldHideLeftNavigation}
        isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
      />
    );
  };

  const showGenericCarousel = showNewCarousel(
    plpTopPromos,
    isPLPCarouselEnabled,
    genericCarouselData
  );

  const TopPromoWrapperStyle = getIsVariation3OutfitCarousel(
    isGenericSBCRedesignEnabled,
    showGenericCarousel,
    plpTopPromos
  )
    ? TopPromoWrapperV3
    : TopPromoWrapper;

  const showStyliticsCarousel = categoryId && styliticsV3CarouselTags[categoryId];
  const { isDesktop = true, isTablet, isMobile } = getViewportInfo() || {};
  let seoUrlPayload = {};

  if (isFacetedNavigationEnabled) {
    let clothingSize = {};
    if (isCleanUrlForSizeEnabled && filterMaps?.v_clothingsize_uFilter) {
      clothingSize = filterMaps.v_clothingsize_uFilter;
    }
    const { asPath, filtersFromUrl } = getFiltersPayloadSeo(
      pathName,
      {
        ...initialValues,
      },
      isFacetedNavigationEnabled,
      seoFacetedNavigationConfig,
      { isCleanUrlForSizeEnabled, clothingSizeMap: clothingSize }
    );
    const formDetails = getFormData(filtersFromUrl);
    seoUrlPayload = {
      formDetails,
      asPath,
      seoFacetedNavigationConfig,
      clothingSizeObj: {
        isCleanUrlForSizeEnabled,
        clothingSizeMap: clothingSize,
      },
    };
  }
  const {
    formDetails: formDetailsForModuleFiter,
    clothingSizeObj: clothingSizeObjForModuleFilter,
  } = seoUrlPayload;

  const shouldShowEmptyCategory =
    hasMounted &&
    ((totalProductsCount === 0 && !isPaginatedPlpLoading) || isStageHoldCategoryOosMessage);

  const shouldShowCategoryModuleFilter =
    !shouldShowEmptyCategory && isQuickFiltersModuleEnabled && !isDesktop;

  const hidePromoOnFilterApplied = checkFilterAppliedStatus(
    appliedFilterIdsAndLength?.filterCount,
    isBopisFilterOn,
    appliedSort
  );

  const getSEOData = (plpProducts, titleSeo, longDesc) => {
    const firstFourProducts = (plpProducts || [])
      .filter((product) => !product.isTitle && !product.isESpotPlpContent)
      .slice(0, 4);

    const updatedSeoTitle = removePatternsFromSeoTitle(titleSeo);
    const description = removePatternsFromSeoTitle(extractPTagContent(longDesc));

    const title = !isEmpty(updatedSeoTitle)
      ? updatedSeoTitle.split('|').map((str) => str.trim())[0]
      : '';

    const apiConfig = getAPIConfig();

    return {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: title,
      description,
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: firstFourProducts.map((product, index) => {
          const brandAttribute = isCanada()
            ? 'TCPPrimaryBrandCanadaStore'
            : 'TCPPrimaryBrandUSStore';
          const brand = extractAttributeValue(product, brandAttribute);

          const { assetHost, assetPath } = getImageAssetConfig(brand.toLowerCase(), apiConfig);
          const assetHostBaseUrl = extractBaseUrl(assetHost);

          const { fullImageUrl } = getImageData({
            stylePartNo: product.style_partno,
            productPartNo: product.prodpartno,
            assetPath,
            imageName: product.productimage,
            altImage: product.alt_img,
            primaryBrand: brand,
            assetHostBaseUrl,
          });

          const isBundle = isBundleProduct(product);

          let price;
          if (isBundle) {
            if (product.tcp_promo_price) {
              const prices = product.tcp_promo_price
                .split('-')
                .map((p) => parseFloat(p.trim()))
                .filter((p) => !Number.isNaN(p));

              if (prices.length > 0) {
                price = Math.min(...prices).toFixed(2);
              }
            } else {
              price = product.low_offer_price;
            }
          } else {
            price = product.tcp_promo_price || product.min_offer_price;
          }

          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Product',
              name: product.product_name,
              image: fullImageUrl,
              ...(product.TCPBazaarVoiceRating && product.TCPBazaarVoiceReviewCount
                ? {
                    aggregateRating: {
                      '@type': 'AggregateRating',
                      ratingValue: product.TCPBazaarVoiceRating,
                      reviewCount: product.TCPBazaarVoiceReviewCount,
                    },
                  }
                : {}),
              offers: {
                '@type': 'Offer',
                priceCurrency: isCanada() ? 'CAD' : 'USD',
                price,
                availability: 'https://schema.org/InStock',
              },
              brand: {
                '@type': 'Brand',
                name: getPdpBrandLabel({
                  primaryBrand: brand,
                }),
              },
            },
          };
        }),
      },
    };
  };

  return (
    <>
      {isCollectionSeoPlpEnabled && (
        <div>
          <script
            type="application/ld+json"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(getSEOData(paginatedProducts, seoTitle, longDescription)),
            }}
          />
        </div>
      )}
      {isSeoHeaderAlignTopEnabled && !hidePlpGridAndFilters && !isEmpty(seoHeaderCopy) ? (
        <SeoHeaderSection
          isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
          seoHeaderCopy={seoHeaderCopy}
          viewMode={'tablet'}
          isFacetedNavigationEnabled={isFacetedNavigationEnabled}
          appliedFilterIdsAndLength={appliedFilterIdsAndLength}
          isPaginatedPlp
        />
      ) : (
        <></>
      )}
      <CategoryPromotionWrapper tablet>
        <CategoryPromotion categoryId={currentNavId} />
      </CategoryPromotionWrapper>
      <TopPromoWrapperStyle className="topWrapper" tablet>
        {renderTopPromos(true)}
      </TopPromoWrapperStyle>
      <PlpGrid>
        {!isSeoHeaderAlignTopEnabled && !hidePlpGridAndFilters && seoHeaderCopy ? (
          <RenderText className={'seo-header-text-block'} richTextHtml={seoHeaderCopy} tablet />
        ) : (
          <></>
        )}
        {!!showStyliticsCarousel && (isTablet || isMobile) && (
          <StyliticsCarouselView
            isTopPromoConfig
            slot={'topPromo_1'}
            pageCategoryId={currentNavId}
            CATEGORY_TAG_HP={styliticsV3CarouselTags[currentNavId]}
          />
        )}
        {shouldShowCategoryModuleFilter && (
          <CategoryModuleFilter
            categoryModuleFilters={categoryModuleFilters}
            updateBopisFormValue={updateBopisFormValue}
            pathName={pathName}
            formDetails={formDetailsForModuleFiter}
            isFacetedNavigationEnabled={isFacetedNavigationEnabled}
            seoFacetedNavigationConfig={seoFacetedNavigationConfig}
            cleanUrlObj={clothingSizeObjForModuleFilter}
            setUpdatedUrlActn={setUpdatedUrlActn}
            appliedFilters={appliedFilters}
            isLoadingMore={isPaginatedPlpLoading}
            newFormData={newFormData}
            setPriceFilterFlagActn={setPriceFilterFlagActn}
            filterMaps={filterMaps}
            isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
          />
        )}
        {isPaginatedPlpLoading && isInitialCall && !hidePlpGridAndFilters ? (
          <StyledLoaderSkelton />
        ) : (
          !hidePlpGridAndFilters && (
            <CategoryFilters
              navTree={navTree}
              pathName={pathName}
              recordsPerPage={recordsPerPage}
              initialValues={initialValues}
              selectedPageProductCount={selectedPageProductCount}
              setClickAnalyticsData={setClickAnalyticsData}
              sortByRatingLabel={sortByRatingLabel}
              isFacetedNavigationEnabled={isFacetedNavigationEnabled}
              seoFacetedNavigationConfig={seoFacetedNavigationConfig}
              setPriceFilterFlagActn={setPriceFilterFlagActn}
              shouldHideLeftNavigation={shouldHideLeftNavigation}
              isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
            />
          )
        )}
        <TrendingInCategoryCarouselWrapper tablet>
          <TrendingInCategoryCarousel
            isTrendingInCategoryRecommendationsEnabled={
              isTrendingInCategoryRecommendationsEnabled && hasMounted
            }
            processedBreadCrumbs={processedBreadCrumbs}
            appliedFilterIdsAndLength={appliedFilterIdsAndLength}
            isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
              isTrendingInCategoryRecommendationsDisplayBadgeEnabled
            }
            trendingInCategoryCarouselCatIds={trendingInCategoryCarouselCatIds}
          />
        </TrendingInCategoryCarouselWrapper>
        {!hidePlpGridAndFilters && !isPLPSortAndOneHrFilterRedesignEnabled && (
          <ItemsCountWrapper isOneHrFilterEnabled={isOneHrFilterEnabled}>
            <ItemsCount>{totalProductsCount > 0 ? totalProductsCount : 0}</ItemsCount>
            <ItemsText>{totalProductsCount > 1 ? ItemsLabel : ItemLabel}</ItemsText>
          </ItemsCountWrapper>
        )}
        <PlpGridColumn grow>
          {isSeoHeaderAlignTopEnabled && !hidePlpGridAndFilters && !isEmpty(seoHeaderCopy) ? (
            <SeoHeaderSection
              isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
              seoHeaderCopy={seoHeaderCopy}
              viewMode={'desktop'}
              isFacetedNavigationEnabled={isFacetedNavigationEnabled}
              appliedFilterIdsAndLength={appliedFilterIdsAndLength}
              isPaginatedPlp
            />
          ) : (
            <></>
          )}
          <CategoryPromotionWrapper desktop>
            <CategoryPromotion categoryId={currentNavId} />
          </CategoryPromotionWrapper>
          <TopPromoWrapper desktop>{renderTopPromos(false)}</TopPromoWrapper>
          {!isSeoHeaderAlignTopEnabled && !hidePlpGridAndFilters && seoHeaderCopy ? (
            <RenderText className={'seo-header-text-block'} richTextHtml={seoHeaderCopy} desktop />
          ) : (
            <></>
          )}
          {!!showStyliticsCarousel && isDesktop && (
            <StyliticsCarouselView
              isTopPromoConfig
              slot={'topPromo_1'}
              pageCategoryId={currentNavId}
              CATEGORY_TAG_HP={styliticsV3CarouselTags[currentNavId]}
            />
          )}
          <TrendingInCategoryCarouselWrapper desktop>
            <TrendingInCategoryCarousel
              isTrendingInCategoryRecommendationsEnabled={
                isTrendingInCategoryRecommendationsEnabled && hasMounted
              }
              processedBreadCrumbs={processedBreadCrumbs}
              appliedFilterIdsAndLength={appliedFilterIdsAndLength}
              isTrendingInCategoryRecommendationsDisplayBadgeEnabled={
                isTrendingInCategoryRecommendationsDisplayBadgeEnabled
              }
              trendingInCategoryCarouselCatIds={trendingInCategoryCarouselCatIds}
            />
          </TrendingInCategoryCarouselWrapper>
          {!hidePlpGridAndFilters && (
            <PlpGridColumn breadcrumbs grow>
              <PaginatedPage
                pathName={pathName}
                paginationObj={paginationObj}
                totalProductsCount={totalProductsCount}
                recordsPerPage={recordsPerPage}
                paginatedProducts={paginatedProducts}
                onQuickViewOpenClick={onQuickViewOpenClick}
                onAddItemToFavorites={onAddItemToFavorites}
                onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                wishListData={wishListData}
                plpGridPromos={plpGridPromos}
                plpCrossPromos={plpCrossPromos}
                isShortImage={isShortImage}
                submitSortChange={submitSortChange}
                navTree={navTree}
                processedBreadCrumbs={processedBreadCrumbs}
                isBopisFilterOn={isBopisFilterOn}
                isPaginatedPlpLoading={isPaginatedPlpLoading}
                isL2Category={isL2Category}
                isInitialCall={isInitialCall}
                pageNumber={pageNumber}
                promotionsData={promotionsData}
                serverTime={serverTime}
                isBuyMorePromoEnabled={isBuyMorePromoEnabled}
                trackClickPromotion={trackClickPromotion}
                setUpdatedUrlActn={setUpdatedUrlActn}
                plpTopPromos={plpTopPromos}
                dynamicPromoModules={dynamicPromoModules}
                trackWishListClick={trackWishListClick}
                isLoggedIn={isLoggedIn}
                setClickAnalyticsData={setClickAnalyticsData}
                saveProductDataForPdp={saveProductDataForPdp}
                saveProductDataForQV={saveProductDataForQV}
                isPlcc={isPlcc}
                isInternationalShipping={isInternationalShipping}
                isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                genericCarouselData={genericCarouselData}
                isShowL2Skeleton={isShowL2Skeleton}
                currencySymbol={currency}
                currencyAttributes={currencyAttributes}
                isTopRatedBackAbEnabled={isTopRatedBackAbEnabled}
                isBestSellerBackAbEnabled={isBestSellerBackAbEnabled}
                isSyteEnabled={isSyteEnabled}
                isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
                isServiceError={isServiceError}
                isNewPLPAtbCardTileEnabled={isNewPLPAtbCardTileEnabled}
                isNewPLPImageBorderEnabled={isNewPLPImageBorderEnabled}
                isNewPlpPaginatorEnabled={isNewPlpPaginatorEnabled}
                isPLPCategoryPillsEnabled={isPLPCategoryPillsEnabled}
                isNewPlpPaginatorShowingResultEnabled={isNewPlpPaginatorShowingResultEnabled}
                isAlternatePlpEnabled={isAlternatePlpEnabled}
                currentNavIds={currentNavIds}
                trackCategoryPillClick={trackCategoryPillClick}
                isPaginatedAlternatePlpEnabled={isPaginatedAlternatePlpEnabled}
                trackPaginationClick={trackPaginationClick}
                isNewNavigationImagesEnabled={isNewNavigationImagesEnabled}
                sortByRatingLabel={sortByRatingLabel}
                addToBagEcom={addToBagEcom}
                isOneClickATCEnabled={isOneClickATCEnabled}
                isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
                isMostFavoritedBadgeEnabled={isMostFavoritedBadgeEnabled}
                setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
                isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
                isRatingRedesignAbTest={isRatingRedesignAbTest}
                isTileRedesignAB={isTileRedesignAB}
                isInfluencerPicksEnabled={isInfluencerPicksEnabled}
                favAddRemoveLoadingState={favAddRemoveLoadingState}
                toastModalState={toastModalState}
                showToastModalAction={showToastModalAction}
                isAlternateImageOnHoverEnabled={isAlternateImageOnHoverEnabled}
                shouldRenderSkeletonComponent={shouldRenderSkeletonComponent}
                isShowPriceRangeEnabled={isShowPriceRangeEnabled}
                isFacetedNavigationEnabled={isFacetedNavigationEnabled}
                seoFacetedNavigationConfig={seoFacetedNavigationConfig}
                isOneHrFilterEnabled={isOneHrFilterEnabled}
                isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                imageConfigWithoutDPR={imageConfigWithoutDPR}
                seoUrlPayload={seoUrlPayload}
                isStageHoldCategoryOosMessage={isStageHoldCategoryOosMessage}
                isFullWidthInGridPromoHidden={isFullWidthInGridPromoHidden}
                isDynamicColorSwatchesEnabled={isDynamicColorSwatchesEnabled}
                isHoverToPreviewColorSwatchesEnabled={isHoverToPreviewColorSwatchesEnabled}
                isInteractiveColorSwatchBandEnabled={isInteractiveColorSwatchBandEnabled}
                isHoverToRevealATBButtonEnabled={isHoverToRevealATBButtonEnabled}
                isFacetedNavigationNoIndexApplicableCheck={
                  isFacetedNavigationNoIndexApplicableCheck
                }
                isFourTileGridEnabled={isFourTileGridEnabled}
                isSwatchAsColorUrlEnabled={isSwatchAsColorUrlEnabled}
                isFeatureBrandEnabled={isFeatureBrandEnabled}
                isQuickFiltersModuleEnabled={isQuickFiltersModuleEnabled}
                categoryModuleFilters={categoryModuleFilters}
                updateBopisFormValue={updateBopisFormValue}
                appliedFilters={appliedFilters}
                newFormData={newFormData}
                setPriceFilterFlagActn={setPriceFilterFlagActn}
                filterMaps={filterMaps}
                isPLPDynamicGridHeroEnabled={isPLPDynamicGridHeroEnabled}
                isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
                hideFilters={hideFilters}
                setHideFilters={setHideFilters}
                isQuickFiltersEnabled={isQuickFiltersEnabled}
                isRemoveCategoryBreakEnabled={isRemoveCategoryBreakEnabled}
                quickFilters={quickFilters}
                isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
                isFinalSaleABEnabled={isFinalSaleABEnabled}
                hidePromoOnFilterApplied={hidePromoOnFilterApplied}
                isRandomBgColorEnabled={isRandomBgColorEnabled}
                isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
                isFadeImageHoverEnabled={isFadeImageHoverEnabled}
                isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
                addToDefaultFavoritesEnabled={addToDefaultFavoritesEnabled}
              />
              <StyledReadMore
                description={longDescription}
                className={`${className} seo-text`}
                appliedFilterIdsAndLength={appliedFilterIdsAndLength}
                isFacetedNavigationEnabled={isFacetedNavigationEnabled}
              />
              {!isPixleeWidget && categoryId ? (
                <SpotlightsLazyLoaded
                  key={categoryId}
                  spotlightUrl={spotlightUrl}
                  categoryId={categoryId}
                />
              ) : (
                <></>
              )}
            </PlpGridColumn>
          )}
        </PlpGridColumn>
      </PlpGrid>
    </>
  );
};

PaginatedPageContainer.propTypes = {
  pathName: PropTypes.string.isRequired,
  paginationObj: PropTypes.arrayOf(),
  totalProductsCount: PropTypes.number,
  recordsPerPage: PropTypes.number,
  paginatedProducts: PropTypes.arrayOf(),
  onQuickViewOpenClick: PropTypes.func,
  onAddItemToFavorites: PropTypes.func,
  onSetLastDeletedItemIdAction: PropTypes.func,
  wishListData: PropTypes.shape({}),
  plpGridPromos: PropTypes.arrayOf(),
  plpCrossPromos: PropTypes.arrayOf(),
  isShortImage: PropTypes.bool,
  initialValues: PropTypes.shape({}),
  processedBreadCrumbs: PropTypes.arrayOf(),
  selectedPageProductCount: PropTypes.number,
  longDescription: PropTypes.string,
  navTree: PropTypes.arrayOf(),
  isBopisFilterOn: PropTypes.bool,
  isPaginatedPlpLoading: PropTypes.bool,
  isL2Category: PropTypes.bool,
  isInitialCall: PropTypes.bool,
  pageNumber: PropTypes.number,
  className: PropTypes.string,
  setUpdatedUrlActn: PropTypes.func,
  trackClickPromotion: PropTypes.func,
  promotionsData: PropTypes.shape({}),
  serverTime: PropTypes.number,
  isBuyMorePromoEnabled: PropTypes.bool,
  categoryId: PropTypes.string,
  spotlightUrl: PropTypes.string,
  seoHeaderCopy: PropTypes.string,
  isPlcc: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  isBrierleyPromoEnabled: PropTypes.bool,
  isShowL2Skeleton: PropTypes.bool,
  navigationData: PropTypes.arrayOf(),
  isTopRatedBackAbEnabled: PropTypes.bool,
  isBestSellerBackAbEnabled: PropTypes.bool,
  isNewSwatchUrlEnabled: PropTypes.bool,
  isServiceError: PropTypes.bool,
  currentNavIds: PropTypes.arrayOf(),
  isAlternatePlpEnabled: PropTypes.bool,
  isPaginatedAlternatePlpEnabled: PropTypes.bool,
  isGenericSBCRedesignEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  isMostFavoritedBadgeEnabled: PropTypes.bool,
  setPLPSLPAddToCartCTA: PropTypes.string,
  trackPageLoadSearchRedirect: PropTypes.func,
  isTileRedesignAB: PropTypes.bool,
  isInfluencerPicksEnabled: PropTypes.bool,
  toastModalState: PropTypes.shape({
    duration: PropTypes.number,
    showToast: PropTypes.bool,
  }),
  showToastModalAction: PropTypes.func,
  layoutFetched: PropTypes.bool,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  isSeoHeaderAlignTopEnabled: PropTypes.bool,
  isSeoHeaderCopyLoaded: PropTypes.bool,
  isAlternateImageOnHoverEnabled: PropTypes.bool,
  isShowPriceRangeEnabled: PropTypes.bool,
  isPixleeWidget: PropTypes.bool,
  outfitCarouselPillCategories: PropTypes.shape([]),
  isFacetedNavigationEnabled: PropTypes.bool,
  isTrendingInCategoryRecommendationsEnabled: PropTypes.bool,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled: PropTypes.bool,
  clearRecommendationDataForPLP: PropTypes.func,
  trendingInCategoryCarouselCatIds: PropTypes.arrayOf(),
  isUpdatedPromotionsDisplayEnabled: PropTypes.bool,
  imageConfigWithoutDPR: PropTypes.string,
  isOutfitCarouselPillDesignEnabled: PropTypes.bool,
  outfitCarouselPillCategoriesAB: PropTypes.shape([]),
  isOutfitPillVariationEnabledOnAllPlps: PropTypes.bool,
  hidePlpGridAndFilters: PropTypes.bool,
  isHoverToRevealATBButtonEnabled: PropTypes.bool,
  isPLPDynamicGridHeroEnabled: PropTypes.string,
  isCollectionSeoPlpEnabled: PropTypes.bool,
  isFinalSaleABEnabled: PropTypes.bool,
  isTransparentImageSizeReduceEnabled: PropTypes.bool,
};

PaginatedPageContainer.defaultProps = {
  paginationObj: [],
  totalProductsCount: 0,
  recordsPerPage: 30,
  paginatedProducts: [],
  onQuickViewOpenClick: () => {},
  onAddItemToFavorites: () => {},
  onSetLastDeletedItemIdAction: () => {},
  isBopisFilterOn: false,
  wishListData: {},
  plpGridPromos: [],
  plpCrossPromos: [],
  isShortImage: false,
  initialValues: () => {},
  processedBreadCrumbs: [],
  selectedPageProductCount: 30,
  longDescription: '',
  navTree: [],
  isPaginatedPlpLoading: false,
  isL2Category: false,
  isInitialCall: false,
  pageNumber: 1,
  className: '',
  setUpdatedUrlActn: () => {},
  trackClickPromotion: () => {},
  promotionsData: {},
  serverTime: null,
  isBuyMorePromoEnabled: false,
  categoryId: '',
  spotlightUrl: '',
  seoHeaderCopy: '',
  isPlcc: false,
  isBrierleyPromoEnabled: false,
  isShowL2Skeleton: false,
  navigationData: [],
  isTopRatedBackAbEnabled: false,
  isBestSellerBackAbEnabled: false,
  isNewSwatchUrlEnabled: false,
  isServiceError: false,
  currentNavIds: [],
  isAlternatePlpEnabled: false,
  isPaginatedAlternatePlpEnabled: false,
  isGenericSBCRedesignEnabled: false,
  isOneClickATCEnabled: false,
  setPLPSLPAddToCartCTA: null,
  addToBagEcom: () => {},
  trackPageLoadSearchRedirect: () => {},
  isTileRedesignAB: false,
  isInfluencerPicksEnabled: false,
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
  layoutFetched: false,
  User: {},
  APIConfig: {},
  session: {},
  isSeoHeaderAlignTopEnabled: false,
  isSeoHeaderCopyLoaded: false,
  isAlternateImageOnHoverEnabled: false,
  isShowPriceRangeEnabled: false,
  isPixleeWidget: false,
  outfitCarouselPillCategories: [],
  isFacetedNavigationEnabled: false,
  isTrendingInCategoryRecommendationsEnabled: false,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled: false,
  clearRecommendationDataForPLP: () => {},
  trendingInCategoryCarouselCatIds: [],
  isUpdatedPromotionsDisplayEnabled: false,
  imageConfigWithoutDPR: '',
  isOutfitCarouselPillDesignEnabled: false,
  outfitCarouselPillCategoriesAB: [],
  isOutfitPillVariationEnabledOnAllPlps: false,
  hidePlpGridAndFilters: false,
  isHoverToRevealATBButtonEnabled: false,
  isPLPDynamicGridHeroEnabled: false,
  isCollectionSeoPlpEnabled: false,
  isFinalSaleABEnabled: false,
  isTransparentImageSizeReduceEnabled: false,
};

const mapStateToProps = (state) => {
  const paginatedProducts = getCategoryProductsByPage(state);
  const plpCatTitles = getTitleDataPerPage(state);
  const recordsPerPage = getNumberOfProductsPerPage(state);
  const totalProductsCount = getTotalProductsCount(state);
  const productsLength = paginatedProducts?.length
    ? (paginatedProducts.length || 0) - (plpCatTitles || 0)
    : 0;
  const totalCount = totalProductsCount <= recordsPerPage ? totalProductsCount : productsLength;
  return {
    recordsPerPage,
    totalProductsCount,
    paginationObj: getUnbxdCallByPageNumber(state),
    paginatedProducts,
    isNewPLPAtbCardTileEnabled: false,
    plpGridPromos: getPLPGridPromos(state),
    plpCrossPromos: getPlpCrossPromo(state),
    initialValues: getInitialValues(state),
    selectedPageProductCount: totalCount,
    longDescription: getLongDescription(state),
    navigationData: getNavigationData(state),
    isBopisFilterOn: getIsBopisFilterOn(state),
    isPaginatedPlpLoading: getIsPaginatedPlpLoading(state),
    isNewPlpPaginatorEnabled: getIsNewPlpPaginatorEnabled(state),
    isL2Category: getIsL2Category(state),
    isInitialCall: getIsInitialCall(state),
    pageNumber: getCurrentPageNumber(state),
    serverTime: getServerTimeFromState(state),
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    categoryId: getCategoryId(state),
    spotlightUrl: getSpotlightReviewsUrl(state),
    isPlcc: isPlccUser(state),
    isInternationalShipping: getIsInternationalShipping(state),
    isBrierleyPromoEnabled: getIsBrierleyPromoEnabled(state),
    genericCarouselData: getGenericCarousel(state),
    isPLPCarouselEnabled: getIsPLPCarouselEnabled(state),
    isShowL2Skeleton: getIsShowL2Skeleton(state),
    isNewNavigationImagesEnabled: getIsNewNavigationImagesEnabled(state),
    appliedFilters: getAppliedFilters(state),
    appliedSort: getAppliedSortId(state),
    currencyAttributes: getCurrencyAttributes(state),
    currency: getCurrentCurrency(state),
    storeId: getFavoriteStore(state),
    defaultStoreId: getDefaultStore(state),
    isTopRatedBackAbEnabled: getAbTestIsTopRatedBadgeEnabled(state),
    isBestSellerBackAbEnabled: getAbTestIsBestSellerBackAbTestEnabled(state),
    isMostFavoritedBadgeEnabled: getAbTestIsMostFavoritedBackAbEnabled(state),
    isNewSwatchUrlEnabled: getIsNewSwatchURLEnabled(state),
    isServiceError: getIsServiceError(state),
    isNewPLPImageBorderEnabled: getIsNewPlpImageBorderEnabled(state),
    isNewPlpPaginatorShowingResultEnabled: getAbTestIsNewPlpPaginatorShowingResultEnabled(state),
    currentNavIds: getCurrentNavIds(state),
    isAlternatePlpEnabled: getIsAlternatePLPEnabled(state),
    isPaginatedAlternatePlpEnabled: getIsPaginatedAlternatePlpEnabled(state),
    isGenericSBCRedesignEnabled: getIsGenericSBCRedesignEnabled(state),
    sortByRatingLabel: getSortByRatingLabel(state),
    isOneClickATCEnabled: getIsOneClickATCEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    setPLPSLPAddToCartCTA: getABTestSetPLPSLPAddToCartCTA(state),
    isInfluencerBadgeEnabled: getIsInfluencerBadgeEnabledForListingPages(state),
    isRatingRedesignAbTest: getisRatingRedesignAbTest(state),
    isPromotionMessageAB: getIsPromotionRedesignAbTest(state),
    isTileRedesignAB: getTileRedesignAB(state),
    isInfluencerPicksEnabled: getInfluencerPicksEnabled(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    isShowPriceRangeEnabled: getIsShowPriceRange(state),
    toastModalState: getToastModalState(state),
    layoutFetched: getIsLayoutFetched(state),
    currentNavId: getCurrentNavId(state),
    isSeoHeaderAlignTopEnabled: getSeoHeaderAlignTopEnabled(state),
    isAlternateImageOnHoverEnabled: getIsAlternateImageOnHoverEnabled(state),
    isPixleeWidget: isPixleeWebEnabled(state),
    outfitCarouselPillCategories: getOutfitCarouselPillCategories(state),
    isFacetedNavigationEnabled: getIsFacetedNavigationEnabled(state),
    seoFacetedNavigationConfig: getSeoFacetedNavigationConfig(state),
    styliticsV3CarouselTags: getStyliticsV3CarouselTags(state),
    isTrendingInCategoryRecommendationsEnabled:
      getIsTrendingInCategoryRecommendationsEnabled(state),
    isCleanUrlForSizeEnabled: getIsCleanUrlForSizeEnabled(state),
    filterMaps: getFilterMaps(state),
    isTrendingInCategoryRecommendationsDisplayBadgeEnabled:
      getIsTrendingInCategoryRecommendationsDisplayBadgeEnabled(state),
    trendingInCategoryCarouselCatIds: getTrendingInCategoryCarouselCatIds(state),
    recommendationProducts: getProducts(state, Constants.RECOMMENDATIONS_PAGES_MAPPING.PLP),
    isOneHrFilterEnabled: getIsOneHrFilterEnabled(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    imageConfigWithoutDPR: getPLPImageSizeConfig(state),
    isOutfitCarouselPillDesignEnabled: getIsOutfitCarouselPillEnabled(state),
    outfitCarouselPillCategoriesAB: getOutfitCarouselPillCategoriesAB(state),
    sbcDesignVariationRectangle: getSBCDesignVariationRectangle(state),
    sbcDesignVariationCircle: getSBCDesignVariationCircle(state),
    isPromoCallCompleted: getIsPromoCallCompletedForCategory(state),
    hasTopPromos: getIsPromoCombinationHasTopPromos(state),
    aspectRatioForCategory: getAspectRatioForCategory(state),
    isStageHoldCategoryOosMessage: getIsStageHoldCategoriesOosMessage(state),
    isOutfitPillVariationEnabledOnAllPlps: getIsPillVariationEnabledOnAllPlps(state),
    hidePlpGridAndFilters: getIsHidePlpGridAndFilters(state),
    isFullWidthInGridPromoHidden: getIsFullWidthInGridPromoHidden(state),
    isDynamicColorSwatchesEnabled: getIsDynamicColorSwatchesEnabled(state),
    isHoverToPreviewColorSwatchesEnabled: getIsHoverToPreviewColorSwatchesEnabled(state),
    isInteractiveColorSwatchBandEnabled: getIsInteractiveColorSwatchBandEnabled(state),
    isHoverToRevealATBButtonEnabled: getIsHoverToRevealATBButtonEnabled(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    isFadeImageHoverEnabled: getFadeImageHoverEnabled(state),
    isFourTileGridEnabled: getIsFourTileGridEnabled(state),
    isSwatchAsColorUrlEnabled: getTsSwatchColorUrlEnabled(state),
    isFeatureBrandEnabled: getIsClickableBrandBadgesEnabled(state),
    isQuickFiltersModuleEnabled: getIsQuickFiltersModuleEnabled(state),
    categoryModuleFilters: getCategoryModuleFilters(state),
    newFormData: getFormValues('filter-form')(state),
    isPLPDynamicGridHeroEnabled: getIsPLPDynamicGridHeroEnabled(state),
    isQuickFiltersEnabled: getIsQuickFiltersEnabled(state),
    isRemoveCategoryBreakEnabled: getIsRemoveCategoryBreakEnabled(state),
    quickFilters: getQuickFilters(state),
    isFinalSaleABEnabled: getIsFinalSaleBackABEnabled(state),
    isRandomBgColorEnabled: getIsRandomBgColorEnabled(state),
    isCollectionSeoPlpEnabled: getIsCollectionSeoForPlpEnabled(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    seoTitle: getSeoTitle(state),
    isTransparentImageSizeReduceEnabled: getIsTransparentImageSizeReduced(state),
    addToDefaultFavoritesEnabled: getAddToDefaultFavoritesEnabled(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    trackClickPromotion: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    setUpdatedUrlActn: (payload) => {
      dispatch(setConsolidatedPlpRes(payload));
    },
    trackWishListClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
    },
    trackPaginationClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick(payload));
    },
    saveProductDataForPdp: (payload) => {
      dispatch(setPlpProductData(payload));
    },
    saveProductDataForQV: (payload) => {
      dispatch(setPlpDataForQuickView(payload));
    },
    trackPageLoad: (payload) => {
      const {
        products,
        customEvents,
        departmentList,
        categoryList,
        listingSubCategory,
        pageSearchText,
        listingCount,
        pageSearchType,
        internalCampaignId,
        supressProps,
        storeId,
        promoFilterCategoryTrail,
        pageNavigationText,
        plpPaginationcd153,
        ...others
      } = payload;
      pushEventToAdobeAnalytics('internal_campaign_click', internalCampaignId);
      if (payload.pageType === 'search') {
        const { trackPageLoadSearchRedirect } = ownProps;
        trackPageLoadSearchRedirect(payload);
      }
      dispatch(
        setClickAnalyticsData({
          products,
          customEvents,
          departmentList,
          categoryList,
          listingSubCategory,
          pageSearchText,
          listingCount,
          pageSearchType,
          internalCampaignId,
          supressProps,
          storeId,
          promoFilterCategoryTrail,
          pageNavigationText,
          plp_pagination_cd153: plpPaginationcd153,
        })
      );
      const timer = setTimeout(() => {
        dispatch(
          trackPageView({
            props: {
              initialProps: {
                pageProps: {
                  pageData: {
                    ...others,
                  },
                },
              },
            },
          })
        );
        const analyticsTimer = setTimeout(() => {
          dispatch(setClickAnalyticsData({}));
          clearTimeout(analyticsTimer);
        }, 200);
        clearTimeout(timer);
      }, 100);
    },
    trackHorizontalPlpAnalytic: (payload) => {
      const timer = setTimeout(() => {
        dispatch(setClickAnalyticsData(payload));
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 200);
    },
    trackCategoryPillClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick(payload));
    },
    setIsHplpPage: (payload) => {
      dispatch(setIsHplp(payload));
    },
    showToastModalAction: (payload) => {
      dispatch(showToastModal(payload));
    },
    clearRecommendationDataForPLP: (payload) => {
      dispatch(clearRecommendationData(payload));
    },
    updateBopisFormValue: (field, value) => {
      dispatch(change('filter-form', field, value));
    },
    setBopisFilterStateActn: (payload) => {
      dispatch(setBopisFilterState(payload));
    },
    setPriceFilterFlagActn: (payload) => {
      dispatch(setPriceFilterFlag(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaginatedPageContainer);
